import Bugsnag from '@bugsnag/js';

const bugsnagClient = Bugsnag({
  apiKey: 'eb12903c021fdb6c7057f8cd639663b1',
  appVersion: '0.1.0',
});

export default bugsnagClient;
